import { fetchWithRetry } from '@flos/react-ui';
import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import defaultResource from '../resources.json';
import { SettingsState } from '../store/settings.type';
import { IState } from '../types';
import log from '../utils/logger';

const ResourceBundle = createContext<{ [key: string]: string }>({});

const ResourceContext = ({ children }: { children: React.ReactNode }) => {
  const [resourceBundle, setResourceBundle] = useState<{ [key: string]: string }>(defaultResource);
  const {
    endpointConfig: { resourceBundle: host },
  } = useSelector<IState, SettingsState>((state) => state.settings);

  useEffect(() => {
    (async () => {
      try {
        const response = await fetchWithRetry(`${host}/schedule-a-call-back/`, {
          method: 'GET',
        });

        const body = await response.json();
        setResourceBundle({
          ...resourceBundle,
          ...body,
        });
      } catch (e) {
        log.error('Error fetching resource bundle', e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ResourceBundle.Provider value={resourceBundle}>{children}</ResourceBundle.Provider>;
};

export default ResourceContext;

export const useResourceBundle = () => useContext<{ [key: string]: string }>(ResourceBundle);
